<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <path class="fil0" d="M3519.23 3106.69l-1307.52 -1307.52 1307.52 -1307.53c58.42,-58.41 58.41,-154 -0.01,-212.42l-200.12 -200.12c-58.42,-58.42 -154,-58.42 -212.41,0l-1307.53 1307.53 -1307.53 -1307.53c-58.41,-58.42 -153.99,-58.42 -212.41,0l-200.12 200.12c-58.42,58.42 -58.43,154.01 -0.01,212.42l1307.52 1307.53 -1307.52 1307.52c-58.41,58.42 -58.41,154 0,212.41l200.13 200.13c58.41,58.42 154,58.42 212.42,0.01l1307.52 -1307.52 1307.52 1307.52c58.42,58.41 154.01,58.41 212.42,-0.01l200.13 -200.13c58.41,-58.41 58.41,-153.99 0,-212.41z"/>
 </g>
</svg>
